<script setup lang="ts">
import { injectAuthProviderFormContext } from '#layers/access/composables/use-auth-provider-form-context';
import { asStringOrNull } from '#layers/base';
import DisplayNameIconField from '#layers/base/components/Form/DisplayNameIconField.vue';

const { state, previewProviderName } = injectAuthProviderFormContext();
</script>

<template>
	<DisplayNameIconField
		:display-name="asStringOrNull(state.displayName)"
		:icon="asStringOrNull(state.icon)"
		:icon-color="asStringOrNull(state.iconColor)"
		:placeholder="previewProviderName"
		@update:display-name="state.displayName = $event"
		@update:icon="state.icon = $event"
		@update:icon-color="state.iconColor = $event"
	/>
</template>
